"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCommitInfo = exports.alignPattern = exports.plusSign = exports.parenthesized = exports.center = exports.TextAlign = void 0;
var TextAlign;
(function (TextAlign) {
    TextAlign["LEFT"] = "left";
    TextAlign["RIGHT"] = "right";
    TextAlign["CENTER"] = "center";
})(TextAlign = exports.TextAlign || (exports.TextAlign = {}));
const center = (text, length) => text.padStart((text.length + length) / 2).padEnd(length);
exports.center = center;
const parenthesized = (input) => "(" + input + ")";
exports.parenthesized = parenthesized;
const plusSign = (num) => (num > 0 ? "+" : "");
exports.plusSign = plusSign;
const alignPattern = (align = TextAlign.LEFT) => {
    switch (align) {
        case TextAlign.LEFT:
            return ":-";
        case TextAlign.RIGHT:
            return "-:";
        case TextAlign.CENTER:
            return ":-:";
    }
};
exports.alignPattern = alignPattern;
const generateCommitInfo = (repository, commitHash, refCommitHash) => `> Generated at commit: [${commitHash}](/${repository}/commit/${commitHash})` +
    (refCommitHash
        ? `, compared to commit: [${refCommitHash}](/${repository}/commit/${refCommitHash})`
        : "");
exports.generateCommitInfo = generateCommitInfo;
